/** RSI enriched API → chart labels and markers. */

import { chartTimeFromIso } from './adxChartData';

export function rsiChartTime(isoStr, timeframe) {
  if (timeframe === '4h') return chartTimeFromIso(isoStr, '4h');
  return Math.floor(new Date(isoStr).getTime() / 1000);
}

export const RSI_BIAS_LABELS = {
  bear: 'Bear',
  neutral: 'Neutral',
  bull: 'Bull',
};

export const RSI_BIAS_CLS = {
  bear: 'regime-bearish',
  neutral: 'regime-neutral',
  bull: 'regime-bullish',
};

export const RSI_EXTREME_LABELS = {
  oversold: 'Oversold',
  overbought: 'Overbought',
};

export function biasDisplay(bias, extreme) {
  if (extreme && RSI_EXTREME_LABELS[extreme]) {
    return {
      label: RSI_EXTREME_LABELS[extreme],
      cls: extreme === 'oversold' ? 'regime-oversold' : 'regime-overbought',
    };
  }
  if (!bias) return { label: '—', cls: 'regime-none' };
  return {
    label: RSI_BIAS_LABELS[bias] || bias,
    cls: RSI_BIAS_CLS[bias] || 'regime-none',
  };
}

export function buildRsiMarkers(rows, timeframe) {
  const markers = [];
  (rows || []).forEach((row) => {
    const time = rsiChartTime(row.time, timeframe);
    if (!time) return;

    if (row.rsi_buy_signal) {
      markers.push({
        time,
        position: 'belowBar',
        color: '#1F4E8C',
        shape: 'arrowUp',
        text: 'RSI 30↑',
      });
    }
    if (row.rsi_sell_signal) {
      markers.push({
        time,
        position: 'aboveBar',
        color: '#C0571F',
        shape: 'arrowDown',
        text: 'RSI 70↓',
      });
    }
    if (row.rsi_bullish_divergence) {
      markers.push({
        time,
        position: 'belowBar',
        color: '#1F4E8C',
        shape: 'circle',
        text: 'RSI+',
      });
    }
    if (row.rsi_bearish_divergence) {
      markers.push({
        time,
        position: 'aboveBar',
        color: '#A16917',
        shape: 'circle',
        text: 'RSI−',
      });
    }
  });
  return markers;
}

/** Reference line colors: bright when ADX range, dim when trending. */
export function levelLineColors(isRanging) {
  if (isRanging) {
    return {
      l70: 'rgba(192, 87, 31, 0.80)',
      l30: 'rgba(31, 78, 140, 0.80)',
      l55: 'rgba(74, 86, 114, 0.53)',
      l45: 'rgba(74, 86, 114, 0.53)',
    };
  }
  return {
    l70: 'rgba(192, 87, 31, 0.20)',
    l30: 'rgba(31, 78, 140, 0.20)',
    l55: 'rgba(74, 86, 114, 0.27)',
    l45: 'rgba(74, 86, 114, 0.27)',
  };
}
